/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ player: NonNullable<unknown>, team: NonNullable<unknown> }} Push_Roster_Added_TitleInputs */

const th_push_roster_added_title = /** @type {(inputs: Push_Roster_Added_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} เข้าร่วม ${i?.team}`)
};

const en_push_roster_added_title = /** @type {(inputs: Push_Roster_Added_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} joined ${i?.team}`)
};

const ja_push_roster_added_title = /** @type {(inputs: Push_Roster_Added_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} が ${i?.team} に加入`)
};

const zh_push_roster_added_title = /** @type {(inputs: Push_Roster_Added_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} 加入了 ${i?.team}`)
};

const es_push_roster_added_title = /** @type {(inputs: Push_Roster_Added_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} se ha unido a ${i?.team}`)
};

const pt_push_roster_added_title = /** @type {(inputs: Push_Roster_Added_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} entrou no ${i?.team}`)
};

const id_push_roster_added_title = /** @type {(inputs: Push_Roster_Added_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} bergabung dengan ${i?.team}`)
};

const fr_push_roster_added_title = /** @type {(inputs: Push_Roster_Added_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} a rejoint ${i?.team}`)
};

const tl_push_roster_added_title = /** @type {(inputs: Push_Roster_Added_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sumali si ${i?.player} sa ${i?.team}`)
};

const vi_push_roster_added_title = /** @type {(inputs: Push_Roster_Added_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} gia nhập ${i?.team}`)
};

const ko_push_roster_added_title = /** @type {(inputs: Push_Roster_Added_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player}이(가) ${i?.team}에 합류했습니다`)
};

const de_push_roster_added_title = /** @type {(inputs: Push_Roster_Added_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} ist zu ${i?.team} gekommen`)
};

const ru_push_roster_added_title = /** @type {(inputs: Push_Roster_Added_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} перешёл в ${i?.team}`)
};

const tr_push_roster_added_title = /** @type {(inputs: Push_Roster_Added_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player}, ${i?.team} takımına katıldı`)
};

const it_push_roster_added_title = /** @type {(inputs: Push_Roster_Added_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} è entrato in ${i?.team}`)
};

const pl_push_roster_added_title = /** @type {(inputs: Push_Roster_Added_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} dołączył do ${i?.team}`)
};

const uk_push_roster_added_title = /** @type {(inputs: Push_Roster_Added_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} приєднався до ${i?.team}`)
};

const hi_push_roster_added_title = /** @type {(inputs: Push_Roster_Added_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} ${i?.team} में शामिल हुए`)
};

const ar_push_roster_added_title = /** @type {(inputs: Push_Roster_Added_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`انضم ${i?.player} إلى ${i?.team}`)
};

const ms_push_roster_added_title = /** @type {(inputs: Push_Roster_Added_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} menyertai ${i?.team}`)
};

const bn_push_roster_added_title = /** @type {(inputs: Push_Roster_Added_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} ${i?.team}-এ যোগ দিয়েছেন`)
};

const zh_tw2_push_roster_added_title = /** @type {(inputs: Push_Roster_Added_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} 加入了 ${i?.team}`)
};

const zh_hk2_push_roster_added_title = /** @type {(inputs: Push_Roster_Added_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} 加入了 ${i?.team}`)
};

const ur_push_roster_added_title = /** @type {(inputs: Push_Roster_Added_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} ${i?.team} میں شامل ہوئے`)
};

const fa_push_roster_added_title = /** @type {(inputs: Push_Roster_Added_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} به ${i?.team} پیوست`)
};

const sw_push_roster_added_title = /** @type {(inputs: Push_Roster_Added_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} amejiunga na ${i?.team}`)
};

const nl_push_roster_added_title = /** @type {(inputs: Push_Roster_Added_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} is bij ${i?.team} gekomen`)
};

/**
* | output |
* | --- |
* | "{player} joined {team}" |
*
* @param {Push_Roster_Added_TitleInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_roster_added_title = /** @type {((inputs: Push_Roster_Added_TitleInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Roster_Added_TitleInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_push_roster_added_title(inputs)
	if (locale === "ja") return ja_push_roster_added_title(inputs)
	if (locale === "zh") return zh_push_roster_added_title(inputs)
	if (locale === "es") return es_push_roster_added_title(inputs)
	if (locale === "pt") return pt_push_roster_added_title(inputs)
	if (locale === "id") return id_push_roster_added_title(inputs)
	if (locale === "fr") return fr_push_roster_added_title(inputs)
	if (locale === "tl") return tl_push_roster_added_title(inputs)
	if (locale === "vi") return vi_push_roster_added_title(inputs)
	if (locale === "ko") return ko_push_roster_added_title(inputs)
	if (locale === "de") return de_push_roster_added_title(inputs)
	if (locale === "ru") return ru_push_roster_added_title(inputs)
	if (locale === "tr") return tr_push_roster_added_title(inputs)
	if (locale === "it") return it_push_roster_added_title(inputs)
	if (locale === "pl") return pl_push_roster_added_title(inputs)
	if (locale === "uk") return uk_push_roster_added_title(inputs)
	if (locale === "hi") return hi_push_roster_added_title(inputs)
	if (locale === "ar") return ar_push_roster_added_title(inputs)
	if (locale === "ms") return ms_push_roster_added_title(inputs)
	if (locale === "bn") return bn_push_roster_added_title(inputs)
	if (locale === "zh-TW") return zh_tw2_push_roster_added_title(inputs)
	if (locale === "zh-HK") return zh_hk2_push_roster_added_title(inputs)
	if (locale === "ur") return ur_push_roster_added_title(inputs)
	if (locale === "fa") return fa_push_roster_added_title(inputs)
	if (locale === "sw") return sw_push_roster_added_title(inputs)
	if (locale === "nl") return nl_push_roster_added_title(inputs)
	return en_push_roster_added_title(inputs)
});